import {Component, Inject, Input, OnInit} from '@angular/core';
import {CloseButtonComponent} from "../../../shared-modules/global/close-button/close-button.component";
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {TranslateModule} from "@ngx-translate/core";
import {MatRadioButton} from "@angular/material/radio";
import {FormsModule} from "@angular/forms";
import {NgClass, NgForOf, NgIf, TitleCasePipe} from "@angular/common";
import {MatOption, MatSelect} from "@angular/material/select";
import {ToLocalDatePipe} from "../../../pipes/date-methodes/to-local-date.pipe";
// Services
import {ParseDateService} from "@services/date/parse-date.service";
// Constants
import {AvailableSlotsInterface, SlotInterface} from "@interfaces/orders/available-slots.interface";
import {SelectDeliveryTimeComponent} from "./select-delivery-time/select-delivery-time.component";

@Component({
  selector: 'app-delivery-date',
  standalone: true,
  imports: [
    CloseButtonComponent,
    TranslateModule,
    MatRadioButton,
    FormsModule,
    NgClass,
    NgForOf,
    TitleCasePipe,
    ToLocalDatePipe,
    NgIf,
    MatSelect,
    MatOption
  ],
  templateUrl: './delivery-date.component.html',
  styleUrl: './delivery-date.component.scss'
})
export class DeliveryDateComponent{
  @Input() set popupData(data:{slots: Array<AvailableSlotsInterface>, deliverOn: string | null }) {
    if (!data) {return}
    this.dateData = data;
    this.detectSelectedDay();
    this.popup = true;
  }
  popup = false;
  state = [
    {
      key: 'as_soon_as_possible',
    },
    {
      key: 'by_the_time',
    },
    {
      key: 'ask_recipient',
    },
  ];
  selectedId!:number;
  slotList: Array<SlotInterface> = [];
  itemStartValue!: string;
  selectedDayIndex = 0;
  disableSave = true;
  isMobile!: boolean;
  selectedTime:any;

  constructor(
    private dialogRef: MatDialogRef<any>,
    private dialog: MatDialog,
    private dateParseService: ParseDateService,
   @Inject(MAT_DIALOG_DATA) public dateData: { slots: Array<AvailableSlotsInterface>, deliverOn: string | null },
  ) {
  }

  select(index: number): void {
    this.selectedId = index;
  }

  confirm(): void {
    if (this.state[this.selectedId].key === 'as_soon_as_possible') {
      this.dialogRef.close('as_soon_as_possible');
    }
  }


  close(): void {
    this.dialogRef.close()
  }

  detectSelectedDay(): void {
    if (!this.dateData.deliverOn) {
      this.slotList = this.dateData.slots[this.selectedDayIndex]?.slots;
      return;
    }
    const deliverOn = this.dateParseService.toLocaleTime(this.dateData.deliverOn, 'YYYY-MM-DD', true);

    this.selectedDayIndex = this.dateData?.slots?.findIndex((slot: AvailableSlotsInterface) => (slot.slots[0].start.indexOf(deliverOn) >= 0));
    this.slotList = this.dateData?.slots[this.selectedDayIndex]?.slots;
    this.itemStartValue = this.dateData?.deliverOn;
    this.detectChange();
  }

  detectChange(): void {
    this.disableSave = !(!!this.itemStartValue);
  }

  ccc(event:any):void {
    event.preventDefault();
    event.stopPropagation();
  }


  showCurrentSlotTime(slot: Array<SlotInterface>, indexOfDays: number): void {
    this.selectedDayIndex = indexOfDays
    this.slotList = []
    this.slotList = [...slot]
  }

  openSelectTimeDialog(): void {
    const dialog = this.dialog.open(
      SelectDeliveryTimeComponent,
      {
        panelClass: 'class_for_close_button',
        data: this.slotList
      }
    )

    dialog.afterClosed().subscribe(res => {
      if (res) {
        this.selectedTime = res
      }
    })
  }
}
